import { ApiHttpService } from 'src/app/_services/api-http.service';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { StorageService } from 'src/app/_services/storage.service';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { IApiEnvelope, IPageResponse } from '../models/transaction-report.models';
import { IWalletLedgerReportDTO, IWalletLedgerReportFilter } from '../models/wallet-ledger-report.models';

const { API_URLBLAZE } = environment;

@Injectable({
  providedIn: 'root'
})
export default class WalletLedgerReportService {

  constructor(
    private apiHttpService: ApiHttpService,
    private http: HttpClient,
    private storageService: StorageService,
    private router: Router
  ) { }


  getWalletLedgerReport(filter: IWalletLedgerReportFilter): Observable<IApiEnvelope<IPageResponse<IWalletLedgerReportDTO>>> {
    const params = this.buildQueryParams(filter);
    const url = `${API_URLBLAZE}/transaction/v2/wallet-ledger-report`;
    return this.apiHttpService.get(url, { params }).pipe(
      catchError(this.handleError<IApiEnvelope<IPageResponse<IWalletLedgerReportDTO>>>())
    ) as Observable<IApiEnvelope<IPageResponse<IWalletLedgerReportDTO>>>;
  }


  exportWalletLedgerReportCSV(date: string): Observable<Blob> {
    const params = new HttpParams().set('date', date);
    const url = `${API_URLBLAZE}/transaction/v2/wallet-ledger-report/export`;
    return this.http.get(url, {
      params,
      responseType: 'blob'
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.storageService.clean();
          this.router.navigate(['/auth/login']);
        }
        throw error;
      })
    );
  }

  private buildQueryParams(filter: IWalletLedgerReportFilter): HttpParams {
    let params = new HttpParams().set('date', filter.date);

    if (filter.page_no !== undefined) {
      params = params.set('page_no', filter.page_no.toString());
    }
    if (filter.page_size !== undefined) {
      params = params.set('page_size', filter.page_size.toString());
      params = params.set('pageNumber', filter.page_size.toString());
    }

    if (filter.sort_column) {
      const dir = filter.sort_dir ? filter.sort_dir.toUpperCase() : 'DESC';
      params = params.set('sort', `${filter.sort_column},${dir}`);
    }

    if (filter.filters && Array.isArray(filter.filters)) {
      filter.filters.forEach(f => {
        if (f && f.trim() !== '') {
          params = params.append('filter', f.trim());
        }
      });
    }

    return params;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      if (error.status === 401) {
        this.storageService.clean();
        this.router.navigate(['/auth/login']);
      }
      result = error?.error;
      return of(result as T);
    };
  }
}
